import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TabModule } from '@sb/library/tab';
import { StepComponent } from './step/step.component';
import { StepperComponent } from './stepper.component';

@NgModule({
    declarations: [
        StepperComponent,
        StepComponent
    ],
    imports: [
    CommonModule,
    TabModule,
],
    exports: [
        StepperComponent,
        StepComponent
    ]
})
export class StepperModule { }
